import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import { recordLesson, updateLesson } from "../../../services/course";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import AppContext from "../../../contexts/AppContext";

import Waiting from "../../utilities/Waiting";

export class LessionUpdate extends Component {
    state = {
        item: {},
        errors: {},       
        waiting: true,
        selectedFile : ''
       
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;       
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };
    

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;

        let error = this.state.errors;
        error.description = null;
        this.setState({ item: temp, errors: error });
    };    

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        

        if(!fields.title){
            formIsValid = false;
            errors.title = "The title field is required.";
        }
        
        if(!fields.description){
            formIsValid = false;
            errors.description = "The description field is required.";
        }             
        
        this.setState({errors: errors});
        return formIsValid;
    }

    handleSubmit = e => { 
        e.preventDefault();
        const formData = new FormData(e.target); 
        if(this.handleValidation()){  
            let errors = {};          
            formData.append('title',this.state.item.title);
            formData.append('description',this.state.item.description);   
            updateLesson(this.props.match.params.lid, formData)
            .then(response => {
                this.props.history.push(`/admin/courses/${this.props.match.params.id}/lessons`);                              
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });

            //console.log(formData.values(),this.state.item);
        } 
    };
  

    componentDidMount() {
        
        recordLesson(this.props.match.params.lid)
            .then(response => {
                this.setState({                    
                    item: {       
                        title : response.data.title,                       
                        description: response.data.description,                       
                    },
                    meta: response.meta,
                    waiting: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
             
    }

   

    render() {
        return (
            <Fragment>
                {this.state.waiting === true ? (
                    <Waiting></Waiting>
                ) : (
                    <Fragment>
                    <Header></Header>
    
                    <div className="main-content mt-6">
                        <div className="container mt-3">
                            <div className="row justify-content-center">
                                <div
                                    id="formModal"
                                    className="col-12 col-lg-10 col-xl-8"
                                >
                                    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="header-pretitle">
                                                        Update Lesson
                                                    </h6>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <form data-select2-id="14" onSubmit={this.handleSubmit}>                                    
                                        <div className="form-group">
                                            <label htmlFor="title">Title</label>
                                            <input
                                                id="title"
                                                name="title"
                                                onChange={this.onChange}
                                                value={this.state.item.title || '' }
                                                type="text"
                                                className="form-control"
                                            />
                                            {this.state.errors.title ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.title}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="form-group mb-6">
                                            <label
                                                className="mb-1"
                                                htmlFor="description"
                                            >
                                                Description
                                            </label>
                                            <small className="form-text text-muted">
                                                    Describe course requirements.
                                            </small>
                                            <Quill
                                                style={{
                                                    height: "200px"
                                                }}
                                                onChange={this.handleQuillChange}
                                                value={
                                                    this.state.item
                                                        .description || ""
                                                }
                                            ></Quill>
    
                                            {this.state.errors.description ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.description}
                                                </div>
                                            ) : null}
                                        </div>
                                              
                                             
                                        <hr className="mt-5 mb-5" />
                                        <button className="newJob btn btn-block btn-primary text-white">Update Lesson</button> 
                                        
                                        <div className=" btn-block center-text  mb-6 mt-3 d-flex justify-content-center">
                                            <Link
                                                to={`/admin/courses/${this.props.match.params.id}/lessons`}
                                                className="btn btn-link text-muted"
                                            >
                                                Cancel
                                            </Link>
                                           
                                        </div>
                                    </form>                                       
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
                )}
            </Fragment>
        );
    }
}

LessionUpdate.contextType = AppContext;
export default LessionUpdate;



// WEBPACK FOOTER //
// ./src/components/admin/lessons/Update.js